import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import SimpleDropdown from 'components/widgets/SimpleDropdown.vue';
import Stopwords from 'components/project/analysis/results/widgets/Stopwords.vue';
import StopwordsDescription from 'components/project/analysis/create/widgets/StopwordsDescription.vue';
import Project from 'src/api/project';
import { SET_ANALYSIS, SET_MESSAGE } from 'src/store/types';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: {
        SimpleDropdown, Stopwords, StopwordsDescription
    },
    data() {
        // Manually collect information about variants and phrases
        // Ideally this would be made available at the Chrysalis API level
        let numVariants = 0;
        let numTermsWithVariants = 0;
        let numPhrases = this.$store.getters.currentModel.stats.n_phrases;
        Object.values(this.$store.getters.currentModel.terms).forEach((term) => {
            numVariants += term.variants.length;
            if (term.variants.length > 1) {
                numTermsWithVariants += 1;
            }
        });
        return {
            stats: {
                numPhrases: numPhrases,
                numVariants: numVariants,
                numTermsWithVariants: numTermsWithVariants
            },
            defaultDateField: this.$store.getters.defaultDateField,
            phraseDetection: this.$store.getters.currentAnalysis.phrase_detection,
            removeDuplicates: this.$store.getters.currentAnalysis.remove_duplicates,
            stemming: this.$store.getters.currentAnalysis.stemming,
            stopwords: JSON.parse(this.$store.getters.currentAnalysis.stopwords),
            initialStopwords: JSON.parse(this.$store.getters.currentAnalysis.stopwords),
            runUpdate: false,
        };
    },
    computed: {
        ...mapGetters([
            'currentAnalysis', 'currentModel', 'dateFields',
        ]),
        settingsChanged: function () {
            return (this.defaultDateField !== this.$store.getters.defaultDateField ||
                this.phraseDetection !== this.currentAnalysis.phrase_detection ||
                this.removeDuplicates !== this.currentAnalysis.remove_duplicates ||
                this.stemming !== this.currentAnalysis.stemming ||
                !_.isEqual(this.stopwords, this.initialStopwords) ||
                this.runUpdate);
        }
    },
    metaInfo() {
        return {
            title: this.currentAnalysis ? `${this.currentAnalysis.name} Settings - Kapiche` : null
        };
    },
    beforeDestroy() {
        // Remove the modal from DOM  since SemanticUI/Jquery takes it out of the component scope.
        $(this.selector).remove();
        // Semantic UI Modal is officially a steaming turd.
        // It messes with the body height which we rely on in the layout of our app.
        // So, first, we make sure the dimmer is hidden;
        // We don't rely on the `hide` method of the modal, because,
        // it initiates a callback that  can override the body height again.
        $('div.dimmer').dimmer('hide');
        // Now  we fix the body height which Semantic UI Modal takes the liberty to #$@! with.
        document.body.style.height = this.bodyHeight;
    },
    methods: {
        number: FormatUtils.number,
        rerunModal(action) {
            $('.ui.modal.rerun-warning')
                .modal(action);
        },
        rerun() {
            this.rerunModal('show');
            if (!this.currentAnalysis?.project || !this.currentAnalysis?.id)
                return;
            Project.rerunAnalysis(this.currentAnalysis.project, this.currentAnalysis.id, {
                default_date_field: this.defaultDateField || '',
                phrase_detection: this.phraseDetection,
                remove_duplicates: this.removeDuplicates,
                stemming: this.stemming,
                stopwords: JSON.stringify(this.stopwords)
            }).then(() => {
                this.$analytics.track.analysis.rerun({
                    analysisId: this.currentAnalysis.id,
                    defaultDateField: this.defaultDateField || '',
                    phraseDetection: this.phraseDetection,
                    removeDuplicates: this.removeDuplicates,
                    stemming: this.stemming,
                    stopwords: this.stopwords
                });
                this.$router.push({ name: 'project-details', params: { projectId: this.currentAnalysis.project } }, () => {
                    this.$store.commit(SET_MESSAGE, `Analysis ${this.currentAnalysis.name} is being rerun`);
                    this.$store.commit(SET_ANALYSIS, null);
                });
            }).catch((errors) => {
                this.rerunModal('hide');
                document.querySelector('.project-wrapper').scrollTop = 0;
            });
        },
        resetSettings() {
            this.defaultDateField = this.$store.getters.defaultDateField;
            this.phraseDetection = this.$store.getters.currentAnalysis.phrase_detection;
            this.removeDuplicates = this.$store.getters.currentAnalysis.remove_duplicates;
            this.stemming = this.$store.getters.currentAnalysis.stemming;
            this.$refs.stopwords.stopwordList = this.initialStopwords.slice();
        },
        // Invoked when the stopwords are modified
        updateStopwords(stopwords) {
            this.stopwords = stopwords;
        }
    }
});
